import { Dots } from '../Dots'
import { Icon } from '../Icon'
import Button from '../app/design/Button'
import Heading from '../app/design/Heading'

type Props = {
    title?: string
    subtitle?: string
    onCancel?: () => void
}

export function NewChargeProcessingPopover({ title, subtitle, onCancel }: Props) {
    return (
        <div className="relative flex h-full flex-col items-center justify-center">
            <Dots className="mb-14" size="large" dotClassName="bg-primary-700" />
            <div className="text-center">
                <Heading size="lg" className="text-primary-700 mb-6">
                    {title ?? 'Processing...'}
                </Heading>
                <Heading size="xs" className="text-gray-500">
                    {subtitle}
                </Heading>
            </div>
            {onCancel && (
                <Button
                    onClick={onCancel}
                    className="text-danger-400 hover:bg-danger-400 absolute bottom-29 hover:text-white"
                    leftIcon={<Icon icon="close.small" shouldInheritColor />}
                    intent="default"
                >
                    Cancel
                </Button>
            )}
        </div>
    )
}

const ErrorCross = ({ className }: { className?: string }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="158"
        height="158"
        viewBox="0 0 158 158"
        fill="none"
        className={className}
    >
        <path
            d="M156.5 79C156.5 121.801 121.801 156.5 79 156.5C36.1987 156.5 1.5 121.801 1.5 79C1.5 36.1987 36.1987 1.5 79 1.5C121.801 1.5 156.5 36.1987 156.5 79Z"
            stroke="#F34142"
            strokeWidth="3"
        />
        <path
            d="M102.742 55.7096L56.2396 101.12"
            stroke="#F34142"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M56.24 55.7096L102.743 101.12"
            stroke="#F34142"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export function ProcessingFailedPopover({
    message,
    onClose,
}: {
    message?: string
    onClose: () => void
}) {
    return (
        <div className="relative flex h-full flex-col items-center justify-center">
            <ErrorCross className="mb-14 size-[158px]" />
            <div className="text-center">
                <Heading size="lg" className="text-danger-400 mb-6">
                    Payment declined
                </Heading>
                <Heading size="xs" className="text-label-md max-w-2xl text-gray-500">
                    {message ?? 'Please try another payment method'}
                </Heading>
            </div>
            <Button
                leftIcon="chevronLeft.medium"
                onClick={onClose}
                className="absolute bottom-29"
                intent="default"
                size="small"
            >
                Go back
            </Button>
        </div>
    )
}
